import apiClient from '@/api/client'

export interface StudentResponse {
  id: string
  first_name: string
  last_name: string
  dob?: string
  date_of_birth?: string
  sacraments?: string[]
  allergens?: string[]
  allergen_alerts?: string[]
  sacraments_received?: string[]
  class_id?: string | null
  class_name?: string | null
  is_parishioner?: boolean
}

export interface BirthdayReminderResponse {
  student_id: string
  student_name: string
  date_of_birth: string
  birthday_date: string
  days_until_birthday: number
  allergen_alerts: string[]
  parent_name?: string | null
  parent_email?: string | null
  class_names: string[]
}

export interface StudentDetailResponse extends StudentResponse {
  parent_id?: string
  parent_user_id?: string
}

export const studentsApi = {
  async list(): Promise<StudentResponse[]> {
    const { data } = await apiClient.get('/api/v1/students')
    return data
  },
  async get(studentId: string): Promise<StudentDetailResponse> {
    const { data } = await apiClient.get(`/api/v1/students/${studentId}`)
    return data
  },
  async getParentContact(studentId: string): Promise<{
    student_id: string
    parent_name: string | null
    parent_email: string | null
    parent_phone: string | null
    parent_address: string | null
    emergency_contacts: string[]
  }> {
    const { data } = await apiClient.get(`/api/v1/students/${studentId}/parent-contact`)
    return data
  },
  async assign(studentId: string, classId: string | null): Promise<{ ok: true }> {
    const { data } = await apiClient.post(`/api/v1/students/${studentId}/assign`, { class_id: classId })
    return data
  },
  async getBirthdayReminders(classId?: string, daysAhead: number = 14): Promise<BirthdayReminderResponse[]> {
    const params: any = { days_ahead: daysAhead }
    if (classId) params.class_id = classId
    const { data } = await apiClient.get('/api/v1/students/birthday-reminders', { params })
    return Array.isArray(data) ? data : []
  },
}



